var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Dashboard-2",
    "data-name": "Dashboard",
    d: "M4.333,16.333h8A1.333,1.333,0,0,0,13.667,15V4.333A1.333,1.333,0,0,0,12.333,3h-8A1.333,1.333,0,0,0,3,4.333V15A1.333,1.333,0,0,0,4.333,16.333ZM3,25.667A1.333,1.333,0,0,0,4.333,27h8a1.333,1.333,0,0,0,1.333-1.333V20.333A1.333,1.333,0,0,0,12.333,19h-8A1.333,1.333,0,0,0,3,20.333Zm13.333,0A1.333,1.333,0,0,0,17.667,27h8A1.333,1.333,0,0,0,27,25.667V16.333A1.333,1.333,0,0,0,25.667,15h-8a1.333,1.333,0,0,0-1.333,1.333Zm1.333-13.333h8A1.333,1.333,0,0,0,27,11V4.333A1.333,1.333,0,0,0,25.667,3h-8a1.333,1.333,0,0,0-1.333,1.333V11A1.333,1.333,0,0,0,17.667,12.333Z",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.0a3619c3af2635cd2666dc6e4f0b86ca.svg";
export { ForwardRef as ReactComponent };